import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { oidcProviderProps } from './config/auth.config';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...oidcProviderProps}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
